"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value, params) {
  var result = false;
  for (var i = 0; i < params.length; i++) {
    if (value === params[i]) result = true;
  }
  return result;
};